import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form-v6';
import ReactSelectMaterialUi from 'react-select-material-ui';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
import { helperText } from '../../utils/reactHookFormUtils';
export const ErrorLabel = styled.p `
  color: ${theme.palette.error.main};
  font-size: 0.75rem;
  margin: 0;
`;
export const MultiEmailInput = (props) => {
    const [active, setActive] = useState(false);
    const [isSet, setIsSet] = useState(false);
    useEffect(() => {
        if (!isSet) {
            props.setValue(`${props.name}`, props.values);
            setIsSet(true);
        }
    }, [isSet, props]);
    const handleChange = (values) => {
        setActive(true);
        if (!values)
            return;
        let emails = [];
        values.forEach((element) => {
            const emailsSplittedOnSpace = element.split(' ').filter((s) => s !== '');
            emailsSplittedOnSpace.forEach((email) => {
                const emailsSplittedOnComma = email.split(',').filter((s) => s !== '');
                const trimmedEmails = emailsSplittedOnComma.map((email) => email.trim());
                emails = [...emails, ...trimmedEmails];
            });
        });
        props.setValue(`${props.name}`, emails);
        props.trigger([`${props.name}`]);
    };
    const handleEmailValidation = (value) => {
        if (!value)
            return;
        const isInvalidEmail = (email) => /^\S+@\S+\.\S+$/i.test(email) === false;
        if (value.some(isInvalidEmail)) {
            return 'Invalid email';
        }
        return undefined;
    };
    const styles = {
        control: () => ({
            alignItems: 'flex-end',
            minHeight: '30px',
            marginRight: 0,
        }),
        container: () => ({
            marginTop: '10px',
        }),
        menu: () => ({
            display: 'none',
        }),
        dropdownIndicator: () => ({
            display: 'none',
        }),
        indicatorsContainer: () => ({
            margin: 0,
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
    };
    return (_jsxs(_Fragment, { children: [_jsx(Controller, { render: ({ value, onChange, onBlur }) => (_jsx(ReactSelectMaterialUi, { label: props.label, options: props.values ? props.values : [], SelectProps: {
                        isClearable: true,
                        isMulti: true,
                        isCreatable: true,
                        styles: styles,
                        msgNoValidValue: 'true',
                        isValidNewOption: (inputValue) => inputValue !== '',
                        autoFocus: props.autoFocus,
                    }, fullWidth: true, InputLabelProps: {
                        style: {
                            color: active
                                ? theme.palette.primary.main
                                : theme.palette.text.secondary,
                        },
                    }, onChange: (value) => {
                        onChange(value);
                        handleChange(value);
                    }, onBlur: (event) => {
                        onBlur();
                        handleChange([
                            ...(value || []),
                            event.target.value,
                        ]);
                    }, style: { textTransform: 'capitalize' }, values: props.values, name: props.name, onFocusCapture: () => setActive(true), onBlurCapture: () => setActive(false), helperText: "Press Enter or Tab to add" })), rules: {
                    required: props.isRequired ? 'This field is required' : '',
                    validate: (value) => handleEmailValidation(value),
                }, control: props.control, name: props.name }), props.errors && (_jsx(ErrorLabel, { children: helperText(props.name, props.errors) }))] }));
};
